import { useState, useEffect } from 'react';
import styles from '../../../styles/agents.module.css';

function PubMedToolConfig({ config = {}, onChange, disabled = false }) {
    const [localConfig, setLocalConfig] = useState({
        maxResults: config.maxResults || 10,
        sort: config.sort || 'relevance',
        dateRange: config.dateRange || ''
    });
    
    // Store maxResults as string for input field to allow clearing
    const [maxResultsInput, setMaxResultsInput] = useState(String(localConfig.maxResults || 10));
    
    // Sync input value when config prop changes
    useEffect(() => {
        if (config.maxResults !== undefined && config.maxResults !== localConfig.maxResults) {
            setMaxResultsInput(String(config.maxResults));
            setLocalConfig(prev => ({ ...prev, maxResults: config.maxResults }));
        }
    }, [config.maxResults]);

    const handleChange = (field, value) => {
        const updated = { ...localConfig, [field]: value };
        setLocalConfig(updated);
        onChange(updated);
    };
    
    const handleMaxResultsChange = (e) => {
        const value = e.target.value;
        // Allow empty string during editing
        setMaxResultsInput(value);
        
        // Only update config if value is valid number
        if (value === '') {
            // Don't update config yet - wait for blur
            return;
        }
        
        const numValue = parseInt(value);
        if (!isNaN(numValue) && numValue >= 1 && numValue <= 50) {
            handleChange('maxResults', numValue);
        }
    };
    
    const handleMaxResultsBlur = (e) => {
        const value = e.target.value;
        let numValue = parseInt(value);
        
        // If empty or invalid, set to default
        if (value === '' || isNaN(numValue) || numValue < 1) {
            numValue = 10;
        } else if (numValue > 50) {
            numValue = 50;
        }
        
        setMaxResultsInput(String(numValue));
        handleChange('maxResults', numValue);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
            <div className={styles.formGroup} style={{ marginBottom: 0 }}>
                <label className={styles.formLabel}>
                    Max Results
                </label>
                <input
                    type="number"
                    min="1"
                    max="50"
                    value={maxResultsInput}
                    onChange={handleMaxResultsChange}
                    onBlur={handleMaxResultsBlur}
                    disabled={disabled}
                    className={styles.formInput}
                />
                <div className={styles.formHelp}>
                    Maximum number of search results to return (1-50)
                </div>
            </div>

            <div className={styles.formGroup} style={{ marginBottom: 0 }}>
                <label className={styles.formLabel}>
                    Sort Order
                </label>
                <select
                    value={localConfig.sort}
                    onChange={(e) => handleChange('sort', e.target.value)}
                    disabled={disabled}
                    className={styles.formInput}
                >
                    <option value="relevance">Relevance</option>
                    <option value="date">Date (newest first)</option>
                    <option value="author">Author</option>
                </select>
            </div>

            <div className={styles.formGroup} style={{ marginBottom: 0 }}>
                <label className={styles.formLabel}>
                    Date Range (Optional)
                </label>
                <input
                    type="text"
                    placeholder="e.g., 2020:2024"
                    value={localConfig.dateRange}
                    onChange={(e) => handleChange('dateRange', e.target.value)}
                    disabled={disabled}
                    className={styles.formInput}
                />
                <div className={styles.formHelp}>
                    Filter results by publication date range (format: YYYY:YYYY)
                </div>
            </div>
        </div>
    );
}

export default PubMedToolConfig;
